import React, { useEffect } from "react";

export default function AdBanner() {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch {}
  }, []);

  return (
    <div className="container px-3 py-4 text-center">
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-9033879555371063"
        data-ad-slot="5899126379"
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
